import { useState } from 'react';
import axios from 'axios';

const EmailSubscription = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post('/api/emailSubscription/subscribe', {
        email,
      });

      if (response.data.success) {
        setMessage(response.data.message);
        setIsSubscribed(true);
        setEmail('');
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        if (err.response.data.errors.email) {
          setError(err.response.data.errors.email);
        } else if (err.response.data.errors.general) {
          setError(err.response.data.errors.general);
        } else {
          setError('Something went wrong. Please try again.');
        }
      } else {
        setError('Network error. Please check your connection and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error) setError('');
    if (message) setMessage('');
  };

  if (isSubscribed) {
    return (
      <div className="email-subscription-container">
        <div className="card border-success">
          <div className="card-body text-center">
            <div className="text-success mb-3">
              <i className="fas fa-check-circle fa-3x"></i>
            </div>
            <h5 className="card-title text-success">Successfully Subscribed!</h5>
            <p className="card-text">{message}</p>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => setIsSubscribed(false)}
            >
              Subscribe Another Email
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="email-subscription-container">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="text-center mb-3">
            <h4 className="card-title text-primary">
              <i className="fas fa-envelope me-2"></i>
              Never Miss a Deal!
            </h4>
            <p className="card-text text-muted">
              Get the best deals delivered straight to your inbox
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-group mb-3">
              <input
                type="email"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                placeholder="Enter your email address"
                value={email}
                onChange={handleEmailChange}
                disabled={loading}
                required
              />
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading || !email}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Subscribing...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane me-2"></i>
                    Subscribe
                  </>
                )}
              </button>
            </div>

            {error && (
              <div className="alert alert-danger alert-sm" role="alert">
                <i className="fas fa-exclamation-triangle me-2"></i>
                {error}
              </div>
            )}

            {message && (
              <div className="alert alert-success alert-sm" role="alert">
                <i className="fas fa-check-circle me-2"></i>
                {message}
              </div>
            )}
          </form>

          <div className="text-center mt-3">
            <small className="text-muted">
              <i className="fas fa-shield-alt me-1"></i>
              We respect your privacy. <a href="/unsubscribe" style={{textDecoration: 'underline'}}>Unsubscribe</a> at any time.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSubscription;
